<template>
    <div
        @click="selectAddress(address)"
        class="address-card well relative mb-3"
        :class="[isLocalizable(address) ? 'active' : 'disabled', { selected: selected }]"
    >
        <h4 class="mt-0">
            {{ address.name }}
            <span class="grey ml-2">{{
                address.mainAddress ? $l10n.__('Adresse principale') : ''
            }}</span>
        </h4>
        <ul class="m-0">
            <li class="mb-2">{{ address.part1 }}</li>
            <li class="mb-2" v-if="address.part2 != ''">{{ address.part2 }}</li>
            <li class="mb-2" v-if="address.part2 != ''">{{ address.part3 }}</li>
            <li class="mb-2" v-if="address.part2 != ''">{{ address.part4 }}</li>
            <li class="mb-2">{{ address.zip }} {{ address.town }}</li>
            <li>{{ address.countrycode }}</li>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
        address: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            selected: false,
        };
    },

    methods: {
        isLocalizable(address) {
            return address.lat !== null && address.lng !== null ? true : false;
        },

        selectAddress() {
            if (this.address.lat == null || this.address.lng == null) {
                Push.error(
                    this.$l10n.__("Cette addresse n'est pas géolocalisable par nos services"),
                );
                return false;
            } else {
                this.$emit('select-address', this.address, this);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';

.address-card {
    &.disabled {
        color: $gray-60;
    }

    &.active:hover {
        border-color: $gray-100;
        cursor: pointer;
    }

    &.selected {
        border-color: $primary-50;
        border-width: 2px;
    }
}
</style>
